<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogShow"
    :width="width"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :fullscreen="fullscreen"
    :modal-append-to-body="false">
    <div slot="title" class="title">
      <span class="dialog-title">{{ title }}</span>
      <span class="dialog-subtitle">{{ subtitle }}</span>
    </div>
    <slot />
    <span slot="footer" class="dialog-footer">
      <slot name="dialogFoot">
        <el-button v-if="cancelBtnShow" @click="dialogClose">{{ $t("dialogBtn.cancel") }}</el-button>
        <el-button type="primary" @click="dialogConfirm">{{ $t("dialogBtn.confirm") }}</el-button>
      </slot>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'PortalContainDialog',
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: '800px'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ''
    },
    cancelBtnShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {
    dialogClose() {
      this.$emit('update:dialogShow', false)
      this.$emit('dialgoHandleClose')
    },
    dialogConfirm() {
      // this.$emit("update:dialogShow", false);
      this.$emit('dialgoHandleConfirm')
    },
    handleClose() {
      this.dialogClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  .dialog-title {
    font-size: 18px;
    line-height: 24px;
    color: #333;
    font-weight: bold;
  }
  .dialog-subtitle {
    padding-left: 18px;
    font-size: 14px;
    color: #666;
  }
}
/deep/ .el-dialog{
  border-radius: 6px;
}
/deep/ .is-fullscreen {
  padding-bottom: 66px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    height: 100%;
    .el-table {
      &::before {
        height: 0;
      }
    }
  }
  .el-dialog__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
